import React from 'react';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { CourseList } from 'src/components/ProgramDetails/WhatYoullLearn/CourseList';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { SkillsList } from 'src/components/ProgramDetails/WhatYoullLearn/SkillsList';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import styles from './WhatYoullLearn.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const WhatYoullLearn: React.FC<Props> = ({ program, loading }) => {
	const courses = program?.contentItems.some(item => item.category === 'COURSE_OPTION');
	const skills = program?.contentItems.some(item => item.category === 'SKILL');

	if (!courses && !skills) {
		return null;
	}

	return (
		<section
			aria-label="what you'll learn"
			className={styles.sectionContainer}
			data-testid='program-detail-courses-skills'
			data-title="What you'll learn"
			id='detail-learn'
			tabIndex={-1}
		>
			<Typography className={styles.header} testid='whatyoulllearn-section-header' variant='h2'>
				What you&apos;ll learn
			</Typography>

			<Skeleton count={3} dataLoading={loading} height={56}>
				{courses && (
					<section aria-label='courses' className={skills && styles.courses}>
						<CourseList program={program} />
					</section>
				)}

				{skills && <SkillsList program={program} />}

				{program?.syllabusLink ? (
					<Typography className={styles.seeMore} variant='body2'>
						Take a look at{' '}
						<TextLink href={program?.syllabusLink} target='_blank' testid='course-link'>
							more program details
						</TextLink>
					</Typography>
				) : null}
			</Skeleton>
		</section>
	);
};
